import React from 'react';
import { RevenueReport } from './reports/ReportComponents';

export default function ReportRevenue() {
  return (
    <div style={{ maxWidth: '1600px' }}>
      <h2 style={{ margin: '0 0 20px' }}>Revenue Recognition</h2>
      <RevenueReport />
    </div>
  );
}
